import { Ref, useRef } from 'react';

import Popup from './popup';

export function usePopupRefs<T>(): [Popup | null, Ref<Popup>, Ref<T>] {
    const popupRef = useRef<Popup | null>(null);
    const targetRef = useRef<T | null>(null);

    const setOwner = () => {
        if (popupRef.current && targetRef.current) {
            popupRef.current.setOwner<T>(targetRef.current);
        }
    };
    const handlePopupRef = (ref: Popup) => {
        popupRef.current = ref;
        setOwner();
    };
    const handleTargetRef = (ref: T) => {
        targetRef.current = ref;
        setOwner();
    };

    return [popupRef.current, handlePopupRef, handleTargetRef];
}
